import actionType from 'utils/mw/actionType.util';

// noinspection JSUnusedGlobalSymbols
export default actionType('RESEND_CONFIRMATION_CODE');
